import { getPortalProjectImage, getPortalSessionSnapshot } from './portalSession';

/**
 * Human-readable project label for the app header.
 * Priority: portal selectedProj.name → VITE_PROJECT_NAME → project id.
 */
export function getProjectDisplayName(): string {
  const fromPortal = getPortalSessionSnapshot()?.projectName?.trim();
  if (fromPortal) {
    return fromPortal;
  }
  const env = (import.meta.env.VITE_PROJECT_NAME as string | undefined)?.trim();
  if (env) {
    return env;
  }
  const id = getPortalSessionSnapshot()?.projectId?.trim();
  if (id) {
    return id;
  }
  return '';
}

/** Portal `project_image` for the active (or given) project. */
export function getProjectDisplayImage(projectId?: string): string {
  return getPortalProjectImage(projectId);
}
